import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from '../../components/icons';

export function TermsPageTR() {
  return (
    <div className="min-h-screen freud-bg py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/tr"
          className="inline-flex items-center gap-2 text-chocolate-600 hover:text-sage-600 mb-8 transition-colors font-medium"
        >
          <ArrowLeft className="w-4 h-4" />
          Ana Sayfaya Don
        </Link>

        <div className="freud-card-elevated p-8">
          <div className="flex items-center gap-3 mb-8">
            <div className="p-3 bg-sage-100 rounded-xl">
              <FileText className="w-6 h-6 text-sage-600" />
            </div>
            <h1 className="freud-heading-2xl text-chocolate-900">Kullanim Kosullari</h1>
          </div>

          <div className="prose prose-chocolate max-w-none">
            <p className="freud-text-base text-chocolate-500 mb-6">
              Son guncelleme: {new Date().toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">1. Kosullarin Kabulu</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              NLP OS'e eriserek ve kullanarak, bu Kullanim Kosullarina bagli olmayi kabul etmis olursunuz. Bu kosullari kabul etmiyorsaniz, lutfen hizmetlerimizi kullanmayin.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">2. Hizmet Tanimi</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              NLP OS, bireylerin potansiyellerini, ozelliklerini ve gelisim alanlarini anlamalarina yardimci olmak icin psikolojik degerlendirmeler ve YZ destekli analizler sunar. Hizmetlerimiz yalnizca kisisel gelisim amaciyla tasarlanmistir.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">3. Kullanici Hesaplari</h2>
            <p className="freud-text-base text-chocolate-600 mb-4">
              Bizde hesap olustururken su kosullari yerine getirmelisiniz:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Dogru ve eksiksiz bilgi saglamak</li>
              <li>Hesap kimlik bilgilerinizin guvenligini saglamak</li>
              <li>Bilgilerinizdeki degisiklikleri derhal guncellemek</li>
              <li>Hesabinizdaki tum faaliyetler icin sorumluluk kabul etmek</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">4. Degerlendirme Sonuclari</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              Degerlendirme sonuclari ve YZ analizleri yalnizca bilgilendirme ve kisisel gelisim amaciyla sunulmaktadir. Profesyonel psikolojik degerlendirme, tibbi tavsiye veya klinik teshis yerine kullanilamaz.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">5. Fikri Mulkiyet</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              Platformun tum icerigi, ozellikleri ve islevselligi bize aittir ve telif hakki, ticari marka ve diger fikri mulkiyet yasalari tarafindan korunmaktadir. Yazili iznimiz olmadan kopyalayamaz, degistiremez, dagitamaz veya turev eserler olusturamazsiniz.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">6. Kullanici Davranisi</h2>
            <p className="freud-text-base text-chocolate-600 mb-4">
              Asagidakileri yapmamayi kabul edersiniz:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Platformu herhangi bir yasa disi amac icin kullanmak</li>
              <li>Sistemlerimize yetkisiz erisim saglamaya calismak</li>
              <li>Platformu engellemek veya bozmak</li>
              <li>Hesap kimlik bilgilerinizi baskalariyla paylasmak</li>
              <li>Platformu baskalarina zarar vermek veya somurme amacli kullanmak</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">7. Sorumluluk Sinirlamasi</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              Yasalarin izin verdigi azami olcude, Platformu kullaniminizdan kaynaklanan herhangi bir dolayli, arizi, ozel, sonuc olarak ortaya cikan veya cezai tazminattan sorumlu olmayacagiz.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">8. Degisiklikler</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              Bu Kosullari herhangi bir zamanda degistirme hakkimizi sakli tutariz. Onemli degisiklikler hakkinda kullanicilari e-posta veya Platform uzerinden bilgilendiririz.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">9. Iletisim</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              Bu Kosullar hakkinda sorulariniz varsa, lutfen support@notify.nlpos.app adresinden bizimle iletisime gecin.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
